module.exports = "<app-course-history-list></app-course-history-list>\r\n"